import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { $locale, setLocale } from './state/locale';
import './state/visitedSights';
import './state/sceneOpen';
import { ViewportProvider } from './context/ViewportContext';
import { initAmplitude } from './analytics/amplitude';
import { initPosthog } from './analytics/posthog';
import { startSessionTracking } from './analytics/sessionTracker';
import { startSessionSummaryTracking } from './analytics/sessionSummaryTracker';
import { startSceneTracking } from './analytics/sceneTracker';
import { startTourTracking } from './analytics/tourTracker';
import { startPoiDetailTracking } from './analytics/poiDetailTracker';
import { startPerformanceTracking } from './analytics/performanceTracker';
import { startAssistantTracking } from './analytics/assistantTracker';
import { startNavigationTracking } from './analytics/navigationTracker';
import { startProgressTracking } from './analytics/progressTracker';
import { startChatStateTracking } from './analytics/chatStateTracker';
import { startPhotoTracking } from './analytics/photoTracker';
import { startCameraSessionTracking } from './analytics/cameraSessionTracker';
import { startOverallTracking } from './analytics/overallTracker';
import { startMenuTracking } from './analytics/menuTracker';
import { startHistoricalScenesTracking } from './analytics/historicalScenesTracker';
import { MobilePreviewFrame } from './components/MobilePreviewFrame/MobilePreviewFrame';
import { installViewportMetricsSync } from './utils/visualViewportMetrics';
import './theme/applyTheme';
import './theme/themes.css';
import './main.css';

initAmplitude();
initPosthog();
startSessionTracking();
startSessionSummaryTracking();
startSceneTracking();
startTourTracking();
startPoiDetailTracking();
startPerformanceTracking();
startAssistantTracking();
startNavigationTracking();
startProgressTracking();
startChatStateTracking();
startPhotoTracking();
startCameraSessionTracking();
startOverallTracking();
startMenuTracking();
startHistoricalScenesTracking();

// NOTE: scene mounting is driven by App.tsx via `buildStackFromPath()` →
// `rebuildStack` → `setSceneId` on initial render. A previous direct
// `setSceneId(...)` call lived here with a duplicate SCENE_POI_ID map —
// removed to keep navigation single-sourced and to avoid firing
// `scene_open` twice on initial load (once from this module, once from
// the App effect).
setLocale($locale.getState());

const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('Root element "#app" was not found');
}

installViewportMetricsSync();

ReactDOM.createRoot(rootElement).render(
  <MobilePreviewFrame>
    <ViewportProvider>
      <App />
    </ViewportProvider>
  </MobilePreviewFrame>
);
